import React, { createContext, useContext, useState, type ReactNode } from 'react';
import type { GameState } from '@/features/game/types';

interface GameContextType {
  gameState: GameState | null;
  setGameState: (state: GameState | null) => void;
  isGameCompleted: boolean;
  setIsGameCompleted: (completed: boolean) => void;
}

const GameContext = createContext<GameContextType | undefined>(undefined);

interface GameProviderProps {
  children: ReactNode;
}

export const GameProvider: React.FC<GameProviderProps> = ({ children }) => {
  const [gameState, setGameState] = useState<GameState | null>(null);
  const [isGameCompleted, setIsGameCompleted] = useState(false);

  return (
    <GameContext.Provider value={{
      gameState,
      setGameState,
      isGameCompleted,
      setIsGameCompleted,
    }}>
      {children}
    </GameContext.Provider>
  );
};

export const useGame = (): GameContextType => {
  const context = useContext(GameContext);
  if (context === undefined) {
    throw new Error('useGame must be used within a GameProvider');
  }
  return context;
};
